<template>
  <div class="help padding_top">
    <p><strong>第一步：</strong>点击右上角<span class="orange">【注册】</span>按钮</p>
    <img src="../../../assets/img/userRes_a.png" alt="" width="911">
    <p class="mt"><strong>第二步：</strong>在弹窗中，选择注册身份<span class="orange">【医生注册】</span></p>
    <img src="../../../assets/img/docRes_b.png" alt="" width="452">
    <p><strong>第三步：</strong>选择注册方式<span class="orange">【邮箱注册】【简历投递】【自主注册】</span></p>
    <img src="../../../assets/img/docRes_c.png" alt="" width="657">
    <p><strong>【邮箱注册】：</strong><br/>
      ① 系统将客服邮箱<span class="orange">(service@yshinfo.com)</span>复制至剪切板<br/>
      ② 将简历文档通过邮件，发送至客服邮箱，由客服代注册<br/>
      ③ 注册完成后，将以邮件的形式通知您
    </p>
    <img src="../../../assets/img/docRes_d.png" alt="" width="284">
    <p><strong>【简历投递】：</strong><br/>
      ① 按提示要求填写对应表单内容后，点击<span class="orange">【上传文件】</span>将您的头像、简历和相关证书上传至网站，点击<span
          class="orange">【提交】</span>，文件上传成功<br/>
      ② 网站后台通过审核后，客服帮您注册完成之后，会与您取得联系
    </p>
    <img src="../../../assets/img/docRes_e.png" alt="" width="80%">
    <p><strong>【自主注册】：</strong><br/>
      ① 按提示逐步填写真实信息，提交内容<br/>
      ② 注册成功后进入个人主页<br/>
      ③ 此方式注册医生限制使用7天，7天内后台人员审核信息后取消限制
    </p>
    <img src="../../../assets/img/docRes_f.png" alt="">
  </div>
</template>

<script>
export default {
  name: "resHelp",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
